<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item title-bread md-size-100">
                <div class="md-group pull-left title">
                    AgBi - Precios:&nbsp;
                </div>
                <div class="md-group pull-left">
                     <drop-down direction="down">
                        <md-button slot="title" class="md-button md-info md-sm dropdown-toggle" data-toggle="dropdown">
                        {{optionSelected}}
                        </md-button>
                        <ul class="dropdown-menu dropdown-menu-left">
                            <li><a @click="changeSelectedOption('Granos')">Granos</a></li>
                            <li><a @click="changeSelectedOption('Insumos')">Insumos</a></li>
                        </ul>
                    </drop-down>
                </div>
                <div class="md-group pull-left" style="margin-left:5px;">
                     <drop-down direction="down">
                        <md-button slot="title" class="md-button md-info md-sm dropdown-toggle" data-toggle="dropdown">
                        {{typeSelected}}
                        </md-button>
                        <ul class="dropdown-menu dropdown-menu-left">
                            <li v-for="item in dropDownType" :key="item" @click="changeSelectedType(item)"><a>{{item}}</a></li>
                        </ul>
                    </drop-down>
                </div>
                <info-icon :message="info[3]" />
            </div>
            <div class="md-layout-item md-size-100" style="margin-top:60px">
                <price v-if="ready" :data="data" :headers="headers"  />
            </div>
            <modal @close="closeModal" v-if="displayModal" class="advertising-modal">
                <template slot="body">
                    <img :src="adv[6]" style="max-height: 500px">
                </template>
                <template slot="footer">
                    <md-button class="md-danger md-simple" @click="closeModal">Cerrar</md-button>
                </template>
            </modal>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Price from '@/components/Graphs/Price'
import Modal from '@/components/Modal'
import InfoIcon from "../components/InfoIcon";
export default {
  components: {InfoIcon, Price, Modal},
  data ()  {
    return {
      ready: false,
      optionSelected: 'Granos',
      typeSelected: '',
      data: [],
      displayModal: false,
      headers: [],
      unit:''
    }
  },
  computed: {
    ...mapState(['grains','supplies','prices','info','adv']),
    dropDownType () {
      return (this.optionSelected == 'Granos') ? this.grains : this.supplies;
    }
  },
  watch: {
    typeSelected () {
      this.generateData();
    }
  },
  methods: {
    changeSelectedOption(option) {
      this.optionSelected = option;
      this.typeSelected = (this.optionSelected == 'Granos') ? this.grains[0] : this.supplies[0]
    },
    changeSelectedType(type) {
      this.typeSelected = type;
    },
    getPriceRow() {
      let result = [];

      for (let key in this.prices)
        if (this.prices[key][0] == this.optionSelected  && this.prices[key][1] == this.typeSelected )
          result = this.prices[key].slice(2);

      return result;

    },
    generateData() {
      this.ready = false;
      this.data = this.getPriceRow();
      this.$nextTick(function() {
        this.ready = true
      })
    },
    closeModal() {
      this.displayModal= false;
    },
  },

  mounted() {
    this.typeSelected = this.grains[0];
    this.headers = this.prices[0].slice(3);

    //setTimeout(() => { this.displayModal = true; }, 3000);
    this.generateData();
  }
}
</script>
<style>

</style>

